const FAR_SPACE_FACTOR = 1000;
const FAR_SPACE_WARP_DISTANCE = 0.8 * (FAR_SPACE_FACTOR * 1000);

const constants = {
  LIGTH_SPEED: 299792458, // DOC: im m/s
  INITIAL_CAMERA_Z: 25,
  FAR_SPACE_FACTOR,
  NEAR_SPACE_FACTOR: 10,
  NEAR_SPACE_WARP_DISTANCE: 10000,
  FAR_SPACE_WARP_DISTANCE,
  STATION_TO_PLANET_DISTANCE_DEFAULT: FAR_SPACE_WARP_DISTANCE,
  DOCK_DISTANCE: 2000,
  JUMP_DISTANCE: 2500,
  INSIDE_SECTOR_MAX_DISTANCE: 100000000,
  AU_IN_M: 149597870700,
  AU_IN_KM: 149597870.7,
  LIGHTYEAR_IN_AU: 63241.077,
  MILKWAY_DIAMETER_IN_LIGHTYEAR: 100000,
};

export const ONE_DAY = 86400000;

export default constants;
